/**
 * Opt-in resume / map-return diagnostics (no addresses or team data).
 * Enable: dev server, `?debugResume=1`, or `sessionStorage.puttzin_debug_resume = '1'`.
 */
import * as Sentry from '@sentry/react'

const DEBUG_SESSION_KEY = 'puttzin_debug_resume'

export function isResumeDebugEnabled() {
  if (import.meta.env.DEV) return true
  try {
    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem(DEBUG_SESSION_KEY) === '1') {
      return true
    }
    if (typeof window !== 'undefined' && /\bdebugResume=1\b/.test(window.location.search || '')) {
      return true
    }
  } catch {
    // ignore
  }
  return false
}

/**
 * @param {string} message
 * @param {Record<string, unknown>} [data]
 */
export function resumeBreadcrumb(message, data) {
  if (!isResumeDebugEnabled()) return
  try {
    if (import.meta.env.VITE_SENTRY_DSN) {
      Sentry.addBreadcrumb({
        category: 'resume_recovery',
        message,
        level: 'info',
        data: data ?? {},
      })
    }
  } catch {
    // ignore
  }
  if (import.meta.env.DEV || typeof console !== 'undefined') {
    // eslint-disable-next-line no-console
    console.debug('[resume]', message, data ?? '')
  }
}
